module.exports = __webpack_public_path__ + "static/HomeHeaderImg-efaa09f346fa3a19601470d94bcb91f2.png";